import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { formatNumber } from '@debbie/common/dist';
import helpers from '@debbie/common/dist/economy/helpers';
import * as paymentPlans from '@debbie/common/dist/economy/payment-plans';
import { Interval } from '@debbie/common/dist/economy/payment-plans';
import THEME from '../../theme';
import ArrowRight from '../Icons/ArrowRight';
import Money from '../Money';
import { h } from '@debbie/cortex/dist';
import { getExpirationSettings } from '@debbie/common/dist/economy/helpers/interest';
import { selectTenant } from '@debbie/cortex/dist/tenant/selectors';
import { useDocumentsByReference } from '@debbie/cortex/dist/documents';
import { useCreditor } from '@debbie/cortex/dist/creditors';
const Plan = (props) => {
    const [plan, setPlan] = useState(null);
    const lang = useSelector((s) => s.lang);
    const tenant = useSelector(selectTenant);
    const documentsLoader = useDocumentsByReference(props.singleCase.caseId);
    const documents = h.hasData(documentsLoader) ? documentsLoader.data : null;
    const creditorLoadable = useCreditor(props.singleCase.creditorId);
    const creditor = h.hasData(creditorLoadable) ? creditorLoadable.data : null;
    useEffect(() => {
        if (documents && tenant && creditor) {
            const filteredVouchers = helpers.vouchers.postProcessing(props.caseVouchers, {
                includeIrrecoverableVouchers: false,
                includeDeletedVouchers: false,
                includeExpiredVouchers: false,
            });
            const data = helpers.paymentPlans.gen(JSON.parse(JSON.stringify(filteredVouchers)), documents, getExpirationSettings(tenant, creditor), {
                startDate: props.startDate.toISOString(),
                interval: Interval.MONTH,
                duration: props.duration,
            });
            setPlan(data);
        }
    }, [documents, tenant, creditor]);
    if (!plan)
        return null;
    return (React.createElement(StyledPlan, { active: props.active, onClick: () => props.active
            ? props.onSelectPlan(null, [])
            : props.onSelectPlan(props.id, plan), className: "ui-test-77ceeebb" },
        React.createElement("div", { className: "price" }, plan[0] && (React.createElement("span", null,
            React.createElement(Money, { amount: paymentPlans.getAmount.entry(plan) || 0 }),
            React.createElement("div", null,
                props.singleCase && props.singleCase.currency,
                "/",
                lang.paymentPlans.month),
            paymentPlans.getAmount.upfront(plan) && (React.createElement("div", null,
                React.createElement("span", null,
                    lang.paymentPlans.upfrontPayment,
                    ":"),
                ' ',
                React.createElement(Money, { amount: paymentPlans.getAmount.upfront(plan) || 0 }))),
            paymentPlans.getAmount.rest(plan) && (React.createElement("div", null,
                React.createElement("span", null,
                    lang.paymentPlans.rest,
                    ":"),
                ' ',
                React.createElement(Money, { amount: paymentPlans.getAmount.rest(plan) || 0 })))))),
        React.createElement("h2", null,
            props.duration,
            ' ',
            React.createElement("span", { style: { fontWeight: 'normal' } }, lang.paymentPlans.months)),
        React.createElement("p", null,
            moment(plan[0] && plan[0].date).format(THEME.DATE_FORMAT_SHORT),
            ' ',
            React.createElement(ArrowRight, null),
            ' ',
            moment(plan[plan.length - 1] && plan[plan.length - 1].date).format(THEME.DATE_FORMAT_SHORT)),
        React.createElement("p", null,
            lang.paymentPlans.totalPayment,
            ' ',
            React.createElement("b", null,
                props.singleCase && props.singleCase.currency,
                ' ',
                formatNumber(paymentPlans.getAmount.total(plan))))));
};
export default Plan;
export const StyledPlan = styled.div `
  border-bottom: 1px solid lightgrey;
  transition: padding 0.3s;
  background-color: ${(props) => (props.active ? 'lightgrey' : 'transparent')};
  padding: ${(props) => props.active
    ? `${THEME.GRID_SPACING}px ${THEME.GRID_SPACING}px`
    : `${THEME.GRID_SPACING}px 0`};
  cursor: pointer;

  &:hover {
    padding: ${THEME.GRID_SPACING}px ${THEME.GRID_SPACING}px;
    background-color: ${(props) => (props.active ? 'lightgrey' : '#efefef')};
  }

  &:last-child {
    border-bottom: none;
  }

  & > h2 {
    margin: 0 !important;
  }

  p {
    font-weight: bold;
    color: ${THEME.DARK_COLOR_SECONDARY};
    margin-top: 8px;
  }

  p:last-child {
    font-weight: initial;
    color: inherit;
    margin-bottom: 0px;
  }

  div.price {
    font-size: 3em;
    float: right;
    text-align: right;

    & > span > div {
      font-size: 0.35em;

      &:last-child,
      &.pp-details {
        font-size: 0.5em;

        & > span:first-child {
          font-size: 0.5em;
        }
      }
    }
  }
`;
//# sourceMappingURL=Plan.js.map